






















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
// components
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import HtmlEditor from "@/components/common/TinyMceEditor.vue";
import vSelect from "vue-select";
// types
import { ContentTemplate, Content } from "@/services/contentTemplates/types";
import { contentTemplateValidators } from "@/components/contentTemplates/validators";
import { Channel, ChannelStyle } from "@/services/channels/types";
import { HtmlCSS } from "@/services/posts/postTypes/html";
import { Style } from "@/services/styles/types";
import { PostTypeEnum, CommonAllowedPostSettings } from "@/services/posts/types";
// service methods
import { getContentTemplate, createContentTemplate, updateContentTemplate } from "@/services/contentTemplates/contentTemplateService";
import { getChannelsByType } from "@/services/channels/channelsService";
import { getStyleByType } from "@/services/styles/stylesService";
import { validateForm } from "@/services/validation/validationService";

import i18n from "@/i18n";
import { bus } from "@/bus";
import validate from "@/directives/validate";

@Component<HtmlTemplateForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        HeaderActionButtons,
        UnsavedFormModal,
        HtmlEditor,
        vSelect
    },
    directives: {
        validate
    }
})
export default class HtmlTemplateForm extends Vue {
    @Prop() contentTemplateId!: string;

    // local state
    channels = [] as Array<Channel>;
    styles = [] as Array<Style>;
    channel = null as Channel | any;
    style = null as Style | any;
    editorReload = 0;
    render = false;
    validators = contentTemplateValidators;
    i18n = i18n;
    nextRoute = "";
    routeParams = {};
    saveClicked = false;
    continue = false;
    fetchingActive = false;

    contentTemplate = {
        id: "",
        name: "",
        description: "",
        width: 0,
        height: 0,
        order: 0,
        type: "html",
        isResponsive: false,
        content: {
            html: ""
        } as Content
    } as ContentTemplate;

    // used for comparing if form have changes
    priorContentTemplateState = JSON.parse(JSON.stringify(this.contentTemplate)) as ContentTemplate;

    // lifecycle hooks
    async created() {
        this.fetchData();
    }

    // computed
    get editMode() {
        return !!this.contentTemplateId;
    }

    get channelStyleInfo(): ChannelStyle {
        return {
            width: this.channel ? this.channel.width : this.contentTemplate.width,
            height: this.channel ? this.channel.height : this.contentTemplate.height,
            css: this.style ? this.style.css : { newsbox: "" } as HtmlCSS
        } as ChannelStyle;
    }

    // router events
    async onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue || this.fetchingActive) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            const component = this.$refs.htmlEditor as any;
            if (component) {
                component.emitData();
            }
            const noChanges = this.lodash.isEqual(this.priorContentTemplateState, this.contentTemplate);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    // methods
    fetchData() {
        if (this.contentTemplateId) {
            this.fetchingActive = true;
            getContentTemplate(this.contentTemplateId).then(response => {
                this.contentTemplate = response;
                this.priorContentTemplateState = JSON.parse(JSON.stringify(this.contentTemplate));
                bus.$emit("documentTitle", this.contentTemplate.name);
                this.render = true;
                this.fetchingActive = false;
            });
        } else this.render = true;

        getChannelsByType(PostTypeEnum.html).then(response => {
            this.channels = response;
        });
        getStyleByType(PostTypeEnum.html).then(response => { this.styles = response; });
    }

    async save(back: boolean) {
        if (this.saveClicked) return;

        const component = this.$refs.htmlEditor as any;
        if (component) {
            component.emitData();
        }

        this.saveClicked = true;
        if (!await validateForm([this.validators])) {
            this.saveClicked = false;
            return;
        }

        // create or update
        if (this.editMode) {
            updateContentTemplate(this.contentTemplate).then(() => {
                this.saveClicked = false;
                this.priorContentTemplateState = JSON.parse(JSON.stringify(this.contentTemplate));
                if (back) {
                    this.$router.push({
                        name: "contentTemplates",
                        params: { templateType: "html" }
                    });
                }
            });
        } else {
            createContentTemplate(this.contentTemplate).then((id: string) => {
                this.saveClicked = false;
                this.contentTemplate.id = id;
                this.contentTemplateId = id;
                this.priorContentTemplateState = JSON.parse(JSON.stringify(this.contentTemplate));

                if (back) {
                    this.$router.push({
                        name: "contentTemplates",
                        params: { templateType: "html" }
                    });
                }
            });
        }
    }

    back() {
        this.$router.push({
            name: "contentTemplates",
            params: { templateType: "html" }
        });
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }

    reloadHtmlEditor() {
        this.editorReload++;
    }

    onContentUpdated(data: any) {
        const contentComponentData = JSON.parse(data);
        this.contentTemplate.content.html = contentComponentData.html;
    }

    // preview events
    channelSelected(selectedChannel: Channel | null) {
        if (selectedChannel !== null) {
            const postTypeStyle = selectedChannel ? selectedChannel.allowedPostTypes.find(x => x.postType.toLowerCase() === "html") as CommonAllowedPostSettings : {} as CommonAllowedPostSettings;
            const styleId = postTypeStyle !== undefined ? postTypeStyle.styleId : "";
            const localStyle = this.styles.find(x => x.id === styleId);
            if (localStyle !== undefined) {
                this.style = localStyle;
            }
        }
        this.reloadHtmlEditor();
    }
}
